import * as React from 'react'; 

import { ProductCategoryContext } from '../productCategory/ProductCategoryProvider';
import Header, { HeaderSize } from '../styleguide/Header';
import PropTypes from 'prop-types';

import styles from './CategoryModal.module.css';

const CategoryModal = ({currentCategory='', handleClick}) => {
  
  const { productCategories } = React.useContext(ProductCategoryContext);
  
  return (
    <div className={styles.categoryModal}>
      <div className={styles.headerWrap}>
        <Header size={HeaderSize.Small} text="Product Categories" />
      </div>
      <ul className={styles.categories}>
        { productCategories?.map((category) => {
          // is category selected? 
          const selectedStyle = currentCategory === category.display_name ? styles.selectedCategory : '';
          return (
            <li key={`more${category.name}`} 
                onClick={()=> { handleClick(category.display_name) }} 
                className={`${styles.categoryItem} ${selectedStyle}`} 
                data-val={category.name}>
                  {category.display_name}
            </li>
          )
        }) }
      </ul>
    </div>
  );
};

CategoryModal.propTypes = {
  currentCategory: PropTypes.string,
  handleClick: PropTypes.func.isRequired
}

export default CategoryModal
